import {
  selectAppliedOffers,
  selectAppliedOffersAtCheckoutMap,
  selectAppliedPersonalizedOffers,
  selectBatteryOfferAvailable,
  selectCartEntriesIdsMap,
  selectCmsOffers,
  selectCmsSurpriseOffers,
  selectDiscountAppliedCmsOffer,
  selectDiscountAppliedPersonalizedOffer,
  selectExtendedCmsOffersMap,
  selectIncentiveErrorsFilteredByCode,
  selectIncentiveErrorsWithCode,
  selectIncentivesIds,
  selectIsCartOffersEvaluated,
  selectLoyaltyOffersInCooldown,
  selectOfferFeedbackMap,
  selectOffers,
  selectOffersLoading,
  selectPersonalizedOffers,
  selectSelectedOffer,
  selectSurpriseAvailable,
  selectUpsizeAvailable,
  selectUserOffers,
  selectValidAppliedOffers,
} from './offers/offers.selectors';
import {
  selectAppliedDiscountRewards,
  selectAppliedLoyaltyRewards,
  selectAppliedLoyaltyRewardsArray,
  selectAppliedPoints,
  selectAvailableLoyaltyRewardsMap,
  selectIsPricingRewardApplication,
  selectShouldRefetchOffers,
  selectShouldRefetchRewards,
  selectStagedCartPoints,
  selectTotalTimesRewardApplied,
} from './rewards/rewards.selectors';
import {
  select12DigitSwipeCard,
  selectLoyaltyLoading,
  selectLoyaltyUser,
  selectUser,
} from './user/user.selectors';

export const loyaltySelectors = {
  // Offer actions
  selectAppliedOffers,
  selectAppliedPersonalizedOffers,
  selectBatteryOfferAvailable,
  selectCartEntriesIdsMap,
  selectCmsOffers,
  selectCmsSurpriseOffers,
  selectExtendedCmsOffersMap,
  selectIncentiveErrorsFilteredByCode,
  selectIncentiveErrorsWithCode,
  selectIncentivesIds,
  selectOfferFeedbackMap,
  selectOffers,
  selectOffersLoading,
  selectLoyaltyOffersInCooldown,
  selectPersonalizedOffers,
  selectSelectedOffer,
  selectSurpriseAvailable,
  selectUpsizeAvailable,
  selectUserOffers,
  selectValidAppliedOffers,
  selectDiscountAppliedCmsOffer,
  selectIsCartOffersEvaluated,
  // Rewards actions
  selectAppliedLoyaltyRewards,
  selectAppliedLoyaltyRewardsArray,
  selectAppliedPoints,
  selectAppliedDiscountRewards,
  selectAvailableLoyaltyRewardsMap,
  selectIsPricingRewardApplication,
  selectShouldRefetchRewards,
  selectShouldRefetchOffers,
  selectStagedCartPoints,
  selectTotalTimesRewardApplied,
  // User actions
  select12DigitSwipeCard,
  selectLoyaltyLoading,
  selectUser,
  selectLoyaltyUser,
  selectDiscountAppliedPersonalizedOffer,
  selectAppliedOffersAtCheckoutMap,
};
